import React, { forwardRef, useState } from 'react';

import { Popover } from '@vlabs/monokit/shared/ui/popovers';
import type { FilterPopoverProps } from '@vlabs/monokit/shared/ui/popovers/filter-popover';

import { createdSourcesStore } from './createdSourcesStore';
import { SourceGroupedCheckbox } from './SourceGroupedCheckbox';
import { useEventListFilters } from '../../useEventListFilters';

function SourceFilterPopover(
  {
    style,
    ...props
  }: FilterPopoverProps<string[]>,
  ref: React.ForwardedRef<HTMLDivElement>,
) {
  const { filters, updateFilters } = useEventListFilters();

  const selectedSources = filters.sources ?? [];

  const [createdSources, setCreatedSources] = useState<string[]>(() => createdSourcesStore.get());

  const handleChangeCustomSourceNames = (next: string[]) => {
    createdSourcesStore.set(next);
    setCreatedSources(next);
  };

  return (
    <Popover
      {...props}
      ref={ref}
      rootProps={{
        ...props?.rootProps,
        style,
      }}
    >
      <SourceGroupedCheckbox
        customSourceNames={createdSources}
        onChangeCustomSourceNames={handleChangeCustomSourceNames}
        onChangeSelectedSource={(v) => updateFilters({ sources: v.length > 0 ? v : undefined })}
        selectedSources={selectedSources}
      />
    </Popover>
  );
}

const SourceFilterPopoverWithRef = forwardRef(SourceFilterPopover);
export { SourceFilterPopoverWithRef as SourceFilterPopover };
